// Polyfill
if (!("requestIdleCallback" in window)) {
  window.requestIdleCallback = function (cb, options) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, (options && options.timeout) || 200); // give a bit more time to ensure it fires
  };

  window.cancelIdleCallback = function (id) {
    clearTimeout(id);
  };
}

document.addEventListener("DOMContentLoaded", function () {

  var viewerInitialized = false;

  function init3DViewer() {
    log("init3DViewer");
    var $viewer_a = $('.swiper-slide-360f');
    if ($viewer_a) {
      var model = $viewer_a.attr("model");
      var new_model_viewer = $('<model-viewer>');
      new_model_viewer.attr({
        class: 'model-viewer',
        'key': 'X8GVY12lKjR3cI1mQRICOBXZ1CcrTquSIp4sW3OGhBnk83UQD0BfVD4Wd42Bjj1EfAtON7PYkOyHPPWts4XyqdegPERLMwK2ZlRDFcEum233qNvZq53YkHhLLVjcbSWR',
        'model': model + ""
      });
      $('.swiper-slide-360f').append(new_model_viewer);
      viewerInitialized = true;
    }
  }

  var sliderThumbnail = new Swiper(".slider-thumbnail", {
    slidesPerView: 4,
    spaceBetween: 10,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  let $lgSwiper = document.getElementById("lg-swipper");

  var slider = new Swiper(".slider-swiper", {
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
    on: {
      init: function () {
        log("init lightGallery");

        // requestIdleCallback(init3DViewer);
        // Use it safely
        try {
          requestIdleCallback(function () {
            if (typeof init3DViewer === "function") {
              init3DViewer();
            } else {
              console.warn("init3DViewer not found");
            }
          }, { timeout: 1000 });
        } catch (err) {
          // absolute fallback if requestIdleCallback fails entirely
          setTimeout(init3DViewer, 500);
        }

        const lg = lightGallery($lgSwiper, {
          selector: '.swiper-slide:not(#f360-id)',
          plugins: [lgZoom]
        });
        $lgSwiper.addEventListener("lgBeforeClose", () => {
          slider.slideTo(lg.index, 0);
        });
      },

      touchStart: function (swiper, event) {
        const lastSlideIndex = swiper.slides.length - 1;
        // If the user starts a touch/drag on the 3D viewer, stop Swiper from taking over
        // const targetElement = event.target.closest('#f360-id');
        if (swiper.activeIndex === lastSlideIndex) {
          swiper.allowTouchMove = false; // Disable swiping temporarily
          swiper.params.allowTouchMove = false;
        } else {
          swiper.allowTouchMove = true;  // Enable swiping for other slides
          swiper.params.allowTouchMove = true;
        }
      },

      touchEnd: function (swiper, event) {
        // Restore Swiper's default behavior after interaction
        swiper.allowTouchMove = true;
        swiper.params.allowTouchMove = true;
      }

    },
  });

  slider.on('slideChange', function () {

    // fix size just in case
    var height_1st = $('#lg-swipper > a > img').height();
    document.documentElement.style.setProperty('--dynamic-360f-height', height_1st + 'px');

    if (slider.isEnd && !viewerInitialized) {
      init3DViewer();
    }
  });

  // change selected slider if selected customizer variant is color and have data in "custom.color_en" metafield that matches in slides
  $(".custom-bed-option-container[variant_product_variant_name_for_tooltip='color']").on("click", function () {

    // find the index of the image that has the attribute
    const slides = slider.slides;
    var targetIndex = -1;
    var color = $(this).attr("customizer-variant-color-en-text");

    slides.forEach((slide, index) => {
      var slide_colors = slide.getAttribute('color-tag');
      if (slide_colors) {
        var check = slide_colors.indexOf(color);

        if (check !== -1) {
          targetIndex = index;
        }
      }
    });

    // if found, set that slide active
    if (targetIndex !== -1) {
      slider.slideTo(targetIndex, 200);
      const activeSlide = slides[targetIndex];
      const img = activeSlide.querySelector('img');
      if (img) {
        const imageUrl = img.src;
        var $sticky_overlay_img = $("#sticky-overlay__product-image");
        if ($sticky_overlay_img.length > 0) {
          $sticky_overlay_img.attr("src", imageUrl);
        }
      }
    }
  });

  // if we have product with more then 1 option
  function get_selected_product_variant_id2(product_id) {

    var $selected_product_options = $(".related-products-wrapper .custom-bed-options-container input[checked2='checked'][customizer-product-id=" + product_id + "]");
    var selectedOptions = [];
    $selected_product_options.each(function () {
      var val = $(this).attr("value");
      selectedOptions.push(val);
    });

    var main_product = window.custom_opt['main_product'];
    const selectedVariant = main_product.variants.find(variant => {
      // variant.options is usually an array like ["Large", "Red", null]
      return selectedOptions.every((value, i) => {
        return value === variant.options[i];
      });
    });

    var selected_var_id = selectedVariant ? selectedVariant.id : null;
    return selected_var_id.toString();
  }

  // test
  function on_variant_color_change_change_selected_item(selected_variant_id){
    // find the index of the image that has the attribute
    log("-----------on_variant_color_change_change_selected_item---------------");
    const slides = slider.slides;
    var targetIndex = -1;
    var variant_id = selected_variant_id;

    slides.forEach((slide, index) => {
      var slide_variant_id = slide.getAttribute('variant-id');
      if (slide_variant_id) {
        var check = slide_variant_id.indexOf(variant_id);

        if (check !== -1) {
          targetIndex = index;
        }
      }
    });

    // if found, set that slide active
    if (targetIndex !== -1) {
      slider.slideTo(targetIndex, 200);
      const activeSlide = slides[targetIndex];
      const img = activeSlide.querySelector('img');
      if (img) {
        const imageUrl = img.src;
        var $sticky_overlay_img = $("#sticky-overlay__product-image");
        if ($sticky_overlay_img.length > 0) {
          $sticky_overlay_img.attr("src", imageUrl);
        }
      }
    }
  }

  $(".custom-bed-option-container.custom-color-label-item").on("click", function () {
    var selected_product_id = $(this).attr("customizer-product-id");
    
    setTimeout(function() {
      var selected_variant_id = get_selected_product_variant_id2(selected_product_id);
      log("SELECTED var id from product media gallery");
      log(selected_variant_id);
      on_variant_color_change_change_selected_item(selected_variant_id);
      

    }, 300);
  });
});
